import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export const DATE_FORMAT = 'YYYY/MM/DD';

dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

const getDayOfWeekFromDayOfWeekNumber = (dayOfWeekNumber: number): string => {
  const dayOfweekList = ['日', '月', '火', '水', '木', '金', '土'];
  return dayOfweekList[dayOfWeekNumber];
};

// 日本語表記曜日あり
const formatDateToYearAndMonthAndDayAndDayOfTheWeek = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const dayOfWeek = getDayOfWeekFromDayOfWeekNumber(date.getDay());
  return `${year}年${month}月${day}日(${dayOfWeek})`;
};

const formatDate = (date: string, format?: string): string =>
  dayjs(date)
    .tz('Asia/Tokyo')
    .format(format ?? DATE_FORMAT);

export { formatDateToYearAndMonthAndDayAndDayOfTheWeek, dayjs, formatDate };
